var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBodybenpositive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 413,
    height: 600,
    preserveAspectRatio: "xMidYMax",
    viewBox: "0 0 413 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "body_ben_positive_svg__a",
    d: "M.537 25.136C.537 11.716 11.42.838 24.844.838h264.893c13.424 0 24.307 10.876 24.307 24.298V220.53H.537V25.136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_ben_positive_svg__c",
    d: "M.47 25.54C.47 11.686 11.695.455 25.552.455c13.852 0 25.083 11.235 25.083 25.085v17.068c0 13.854-9.127 31.636-20.38 39.712l-4.703 3.376-4.704-3.376C9.594 74.242.47 56.458.47 42.608V25.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_ben_positive_svg__g",
    d: "M149.822 19.87L227.032 91c0-24.853-17.159-55.773-39.26-67.434 0 0-58.209-46.62-122.091-10.888C65.68 12.678 14 46.166 8 59 0 71.834 0 90.678 0 90.678L76.837 23s52.763 22.75 72.985-3.13z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_ben_positive_svg__e",
    width: 253.072,
    height: 297.496,
    x: 0,
    y: 0,
    rx: 126.536
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(47 21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AF907A",
    stroke: "#363A4F",
    strokeLinejoin: "round",
    strokeWidth: 12.6,
    d: "M184.412-4.735c-4.597-.32-55.69-3.53-82.777 9.856-22.687 4.781-43.39 21.833-58.295 46.145-14.612 23.832-23.642 54.554-23.568 86.528h0l.212 91.54H298.84l1.556-116.71c.435-32.598-12.43-62.237-33.552-83.572C245.87 7.87 216.759-5.136 184.412-4.735z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 358.054)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ben_positive_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ben_positive_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F15165",
    stroke: "#363A50",
    strokeWidth: 10.08,
    xlinkHref: "#body_ben_positive_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#363A50",
    strokeWidth: 10.08,
    d: "M.537 25.136C.537 11.716 11.42.838 24.844.838h264.893c13.424 0 24.307 10.876 24.307 24.298V220.53H.537V25.136z",
    mask: "url(#body_ben_positive_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424A73",
    stroke: "#363A50",
    strokeWidth: 10.08,
    d: "M.9 25.13C.9 11.706 11.778.921 25.204 1.043l81.054.73 13.42 215.757H.9V25.13z",
    mask: "url(#body_ben_positive_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424A73",
    stroke: "#363A50",
    strokeWidth: 10.08,
    d: "M189.866 25.123c0-13.418 10.879-24.2 24.304-24.08l81.055.717 13.42 211.77H189.866V25.123z",
    mask: "url(#body_ben_positive_svg__b)",
    transform: "matrix(-1 0 0 1 498.511 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "235.548 125.189 254.789 100.189 276.548 122.471",
    mask: "url(#body_ben_positive_svg__b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    stroke: "#979797",
    strokeWidth: 0.9,
    points: "255.548 125.189 287.028 100.189 296.548 122.471",
    mask: "url(#body_ben_positive_svg__b)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 10,
    x: 235.548,
    y: 121.518,
    fill: "#363A50",
    mask: "url(#body_ben_positive_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M103.765 38.268s-122.918-43.168-87 179l-34.082-9.832v-209l55-11 45-4 21.082 54.832z",
    mask: "url(#body_ben_positive_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M203.82 22.194s-7.957 57.2-31 57.2l-4.043 151.8-11-5.5 3-176 37-60.5 6.043 33zM156.777 50.962s-37-49.27-22 169.232l-19-6.427 4-219.573 37 56.768z",
    mask: "url(#body_ben_positive_svg__b)"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "245.362 361.42 235.362 392.42 256.362 431.49 201.362 566.42 211.362 379.291 217.362 358.291"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "200.763 359.656 197.163 572.596 245.755 430.689 224.159 395.213 233.157 363.471 200.763 333.596"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "84.923 359.652 81.984 578.596 129.915 430.673 108.319 395.202 117.317 363.466 84.923 333.596",
    transform: "matrix(-1 0 0 1 211.899 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.512,
    cy: 210.145,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.481,
    cy: 215.067,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.031,
    cy: 210.145,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 213.067,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.575 308.547)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ben_positive_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ben_positive_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M25.036-5.84c8.956-.004 16.862 3.49 22.572 9.107 5.786 5.69 9.328 13.57 9.328 22.273h0v17.068c0 15.64-10.303 35.713-23.007 44.83h0l-8.376 6.013-8.377-6.012C4.47 78.319-5.831 58.243-5.831 42.609h0v-17.07c0-8.573 3.437-16.343 9.008-22.007 5.58-5.674 13.303-9.234 21.859-9.373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M25.036-5.84c8.956-.004 16.862 3.49 22.572 9.107 5.786 5.69 9.328 13.57 9.328 22.273h0v17.068c0 15.64-10.303 35.713-23.007 44.83h0l-8.376 6.013-8.377-6.012C4.47 78.319-5.831 58.243-5.831 42.609h0v-17.07c0-8.573 3.437-16.343 9.008-22.007 5.58-5.674 13.303-9.234 21.859-9.373z",
    mask: "url(#body_ben_positive_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M34.763 16.775s-52 11-8 73l-27-13-11-57 1-6 45 3z",
    mask: "url(#body_ben_positive_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.995 36.185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ben_positive_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ben_positive_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#body_ben_positive_svg__e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 240.472,
    height: 284.896,
    x: 6.3,
    y: 6.3,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    mask: "url(#body_ben_positive_svg__f)",
    rx: 120.236
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M9.578 125.172s50-99 70-89 98.852 63.926 167.926 63.926c69.074 0 10.074-25 10.074-25l-98-54-93-19-46 19-31 97 20 7.074zM247.621 163.98s-24 116.172-130 122l50.926 4 88-58-8.926-68z",
    mask: "url(#body_ben_positive_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 9,
    d: "M242.57 138.083c-6.265-10.852-23.549-12.604-38.604-3.912M78.06 138.083c6.265-10.852 23.55-12.604 38.604-3.912"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.394,
    cy: 182.421,
    fill: "#FFF",
    rx: 19.23,
    ry: 14.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.617,
    cy: 182.421,
    fill: "#FFF",
    rx: 19.23,
    ry: 14.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.409,
    cy: 183.135,
    fill: "#363A50",
    rx: 7.554,
    ry: 9.366
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M144.437 237.02s7.148 11.484 15.966 11.484c8.817 0 15.966-11.485 15.966-11.485"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M25.814 202.723c5.371-3.227 12.338-1.495 15.561 3.87h0c3.223 5.364 1.483 12.329-3.888 15.556M279.129 204.684c4.728-4.11 11.89-3.614 15.996 1.109h0c4.106 4.723 3.6 11.884-1.128 15.995"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.171,
    cy: 183.135,
    fill: "#363A50",
    rx: 7.554,
    ry: 9.366
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "94.542 42.135 83.542 64.135 107.542 48.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M114.542 25.135s135-43 172 95c-23.926-157.739-172-95-172-95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M161.573 201.322s-18.074 35 9 43h-17.926l-9-9 17.926-34z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 9,
    d: "M129.915 266.174S146.57 276 161.276 276s33.09-9.826 33.09-9.826"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "150.106 284.142 170.106 284.142 160.106 294.068"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AF907A",
    d: "M91.271 40.218S296.395 169.03 283.14 130.52c0-131.775-191.869-90.302-191.869-90.302z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 10.8,
    d: "M98.067 43.947S244.62 134.194 282.48 139.41"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 163.771,
    x2: 163.771,
    y1: 405.529,
    y2: 574.5,
    stroke: "#363A50",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 137 167.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ben_positive_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ben_positive_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M62.255 7.39c64.336-36 122.967 6.323 128.954 10.87 11.643 6.3 22.08 17.425 29.625 30.386 10.417 17.892 15.268 39.155 10.886 55.238h0l-81.681-75.249c-20.593 17.067-59.48 5.774-71.83 1.552h0l-83.424 73.48C-6.195 97.343-6.296 92.302-6.3 90.9v-.223h0v-.054c.014-1.646.473-21.127 8.803-34.716 5.801-11.122 41.17-36.142 54.754-45.216h0l.931-.621c2.55-1.697 4.067-2.68 4.067-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF907A",
    stroke: "#363A4F",
    strokeLinejoin: "round",
    strokeWidth: 12.6,
    d: "M62.255 7.39c64.336-36 122.967 6.323 128.954 10.87 11.643 6.3 22.08 17.425 29.625 30.386 10.417 17.892 15.268 39.155 10.886 55.238h0l-81.681-75.249c-20.593 17.067-59.48 5.774-71.83 1.552h0l-83.424 73.48C-6.195 97.343-6.296 92.302-6.3 90.9v-.223h0v-.054c.014-1.646.473-21.127 8.803-34.716 5.801-11.122 41.17-36.142 54.754-45.216h0l.931-.621c2.55-1.697 4.067-2.68 4.067-2.68z",
    mask: "url(#body_ben_positive_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9D816D",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M88.14 93.544c12.878-5.187 13.392-26.2 1.148-46.932h0C77.045 25.879 56.68 13.277 43.801 18.465M125.015 79.605c12.879-5.187 13.393-26.2 1.15-46.932C113.92 11.94 93.554-.662 80.675 4.526M156.623 62.181c12.879-5.187 13.393-26.2 1.149-46.932h0c-12.244-20.733-32.61-33.334-45.488-28.147",
    mask: "url(#body_ben_positive_svg__h)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "37 33.457 20.218 23 8 92 27.512 67.342",
    mask: "url(#body_ben_positive_svg__h)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodybenpositive);
export default __webpack_public_path__ + "static/media/body.ben.positive.f1520e96.svg";
export { ForwardRef as ReactComponent };